import { Upload } from '@core/ui';

export const SlideFileUploadIcon = () => <Upload classNames="size-12 mb-1 stroke-current group-hover:stroke-primary transition-color duration-200 ease-in-out" />;
